"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _units = require("../../theme/units");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = _styledComponents["default"].button.withConfig({
  displayName: "BaseButton__Button",
  componentId: "sc-1l8ul5x-0"
})(function (props) {
  return (0, _styledComponents.css)(["line-height:1.5rem;margin:", ";padding:", ";font-family:", ";font-weight:", ";font-size:", ";color:", ";"], _units.globalSizes.small, _units.globalSizes.small, props.theme.font.family, props.theme.font.weight.bold, props.theme.font.base, props.active ? props.theme.color.paper : props.theme.color.action);
});
/**
 *
 * #### Styled button control.

The basic styled base component used by all other buttons.

NOTE: Not intended to be used standalone. Please use the `Button` component instead :-)
 */


exports.Button = Button;

var BaseButton = /*#__PURE__*/_react["default"].forwardRef(function BaseButton(_ref, ref) {
  var type = _ref.type,
      id = _ref.id,
      className = _ref.className,
      value = _ref.value,
      disabled = _ref.disabled,
      error = _ref.error,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onKeyDown = _ref.onKeyDown,
      onKeyUp = _ref.onKeyUp,
      onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      onMouseLeave = _ref.onMouseLeave,
      onMouseUp = _ref.onMouseUp,
      onTouchEnd = _ref.onTouchEnd,
      onTouchMove = _ref.onTouchMove,
      onTouchStart = _ref.onTouchStart,
      onDragLeave = _ref.onDragLeave,
      tabIndex = _ref.tabIndex,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["type", "id", "className", "value", "disabled", "error", "name", "onBlur", "onFocus", "onKeyDown", "onKeyUp", "onClick", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "children"]);

  return /*#__PURE__*/_react["default"].createElement(Button, _extends({
    type: type,
    id: id,
    className: className,
    value: value,
    disabled: disabled,
    error: error,
    name: name,
    onBlur: onBlur,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    onDragLeave: onDragLeave,
    tabIndex: tabIndex,
    ref: ref
  }, rest), children);
});

BaseButton.defaultProps = {
  type: 'button',
  id: null,
  className: null,
  value: '',
  disabled: false,
  error: false,
  name: null,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onClick: function onClick() {},
  onMouseDown: function onMouseDown() {},
  onMouseLeave: function onMouseLeave() {},
  onMouseUp: function onMouseUp() {},
  onTouchEnd: function onTouchEnd() {},
  onTouchMove: function onTouchMove() {},
  onTouchStart: function onTouchStart() {},
  onDragLeave: function onDragLeave() {},
  tabIndex: null,
  children: null
};
var _default = BaseButton;
exports["default"] = _default;